import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TurnsService} from '../../services/turns-services/turns-service/turns.service';
import {ControlDesk} from '../../models/turns-models/control-desk.model';
import {map} from 'rxjs/internal/operators';
import {MaintenanceService} from '../../services/maintenance-service/maintenance.service';
import {Router} from '@angular/router';
import {UserStorageService} from '../../services/user-storage-service/user-storage.service';
import {LocationDesk} from '../../models/turns-models/location-desk.model';
import {Location} from '@angular/common';
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-admin-screen',
  templateUrl: './admin-screen.component.html',
  styleUrls: ['./admin-screen.component.scss']
})
export class AdminScreenComponent implements OnInit {

  desks: Array<ControlDesk>;
  locations: Array<LocationDesk>;
  selectedDesk: ControlDesk;
  selectedLocation: LocationDesk;
  selectedDeskId: string;
  selectedLocationId: string;

  langList = [
    { code: 'en_GB', icon: './assets/icons/flag_uk.png' },
    { code: 'es_ES', icon: './assets/icons/flag_es.png' },
    { code: 'fr_FR', icon: './assets/icons/flag_fr.png' },
    { code: 'pt_PT', icon: './assets/icons/flag_pt.png' },
  ];

  constructor(private maintenanceService: MaintenanceService,
              private turnsService: TurnsService,
              private userStorageService: UserStorageService,
              private router: Router,
              private location: Location,
              private translate: TranslateService,
              private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.maintenanceService.isRegistered().pipe(
      map(registered => {
        if (!registered['isRegistered']) {
          this.router.navigate(['/']);
        } else {
          this.getControlDesks();
          this.getDeskLocations();
        }})
    ).subscribe();

    this.turnsService.listenUpdateDesks().subscribe(
      (res) => {
        this.getControlDesks();
      }
    );

    this.selectedDesk = this.userStorageService.getSelectedDesk();
    this.selectedLocation = this.userStorageService.getSelectedLocationDesk();
  }

  private getControlDesks() {
    this.turnsService.getControlDesks().subscribe(
      (res) => {
        this.desks = res.filter( (d: ControlDesk) => d.type === 'NORMAL');
      },
      (error) => {
        console.dir(error);
      }
    );
  }

  private getDeskLocations() {
    this.turnsService.getDeskLocations().subscribe(
      (res) => {
        this.locations = res;
      },
      (error) => {
        console.dir(error);
      }
    );
  }

  public save() {
    this.userStorageService.setSelectedDesk(this.selectedDesk);
    this.userStorageService.setSelectedLocationDesk(this.selectedLocation);
    this.location.back();
  }

  public setSelectedDesk(desk: ControlDesk) {
    this.selectedDesk = desk;
    this.selectedLocation = null;
    this.selectedLocationId = null;
    this.save();
  }

  public setSelectedLocation(location: LocationDesk) {
    this.selectedLocation = location;
    this.selectedDesk = null;
    this.selectedDeskId = null;
    this.save();
  }

  public enableDesk(desk: ControlDesk) {
    this.turnsService.changeDeskStatus(desk.internalId, true).subscribe();
  }

  disableDesk(desk: ControlDesk) {
    this.turnsService.changeDeskStatus(desk.internalId, false).subscribe();
  }

  public changeLang(lang) {
    this.userStorageService.setLang(lang.code);
    this.translate.use(lang.code);
  }

  isSoundEnabled(): boolean {
    return this.userStorageService.isSoundEnabled();
  }

  toggleSound(): void {
    const currentState = this.isSoundEnabled();
    this.userStorageService.setSoundState(!currentState);
    this.cdr.detectChanges();
  }
}
